/** @jsxImportSource @emotion/react */
import { Container, ProfileContainer, ProfileImg, ProfileName, Rectangle, TitleContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getWorkspaceInfo } from "apis/workspace";
import { useToast } from "hook/useToast";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";
import { UserRole } from "utils/role";

const WorkspaceManage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showToast } = useToast();
  const memberInfo = useRecoilValue(member);

  const [workspaceName, setWorkspaceName] = useState<string>("");
  const [workspaceImage, setWorkspaceImage] = useState<string | null>();

  const navigateEdit = () => {
    navigate(`/setting/${encodeURIComponent("워크스페이스 관리")}/edit`, {
      state: {
        workspaceName: workspaceName,
        workspaceImage: workspaceImage,
      },
    });
  };

  useEffect(() => {
    getWorkspaceInfo().then((res) => {
      if (res.success) {
        setWorkspaceName(res.data?.name ?? "");
        setWorkspaceImage(res.data?.image ?? "");
      }
    });
  }, []);

  useEffect(() => {
    if (location.state?.updateSuccess) {
      showToast("워크스페이스 정보를 수정했습니다.", "success");
      window.history.replaceState({}, "");
    }
  }, [location]);

  return (
    <Container>
      <TitleContainer>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-netural)"
          style={{ padding: "24px 20px" }}
        >
          워크스페이스 관리
        </UI.Typography>
        {memberInfo && memberInfo.role < UserRole.PolicyAdmin && (
          <div style={{ padding: "8px 20px" }}>
            <UI.Button title="워크스페이스 정보 수정하기" onClick={navigateEdit} />
          </div>
        )}
      </TitleContainer>
      <Rectangle />
      <ProfileContainer>
        <ProfileImg
          src={
            workspaceImage
              ? workspaceImage
              : "https://mile-storage.s3.ap-northeast-2.amazonaws.com/web/mile-logo-gray.png"
          }
        />
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 4px;
            text-align: center;
          `}
        >
          <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-alternative">
            워크스페이스 이름
          </UI.Typography>
          <ProfileName>
            <UI.Typography type="headline01" fontStyle="bold">
              {workspaceName}
            </UI.Typography>
          </ProfileName>
        </div>
      </ProfileContainer>
    </Container>
  );
};

export default WorkspaceManage;
